import { render, staticRenderFns } from "./PersonalInfo.vue?vue&type=template&id=630b965a"
import script from "./PersonalInfo.ts?vue&type=script&lang=ts&external"
export * from "./PersonalInfo.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports